import { action, observable, makeObservable } from 'mobx';

class GambleStore {
  hasGamble = false;

  gambleInfo = null;

  isShowGamblePopup = false;

  gambleHistoryCards = [];

  isAllowDoGambleAction = true;

  openedCard = null;

  totalWinAmount = 0;

  isGambleLose = false;

  constructor() {
    makeObservable(this, {
      hasGamble: observable,
      gambleInfo: observable,
      openedCard: observable,
      isGambleLose: observable,
      totalWinAmount: observable,
      isShowGamblePopup: observable,
      isAllowDoGambleAction: observable,
      gambleHistoryCards: observable.deep,
      setHasGamble: action.bound,
      setOpenedCard: action.bound,
      setGambleInfo: action.bound,
      setIsGambleLose: action.bound,
      updateGambleInfo: action.bound,
      setTotalWinAmount: action.bound,
      setIsShowGamblePopup: action.bound,
      setGambleHistoryCards: action.bound,
      updateGambleHistoryCards: action.bound,
      setIsAllowDoGambleAction: action.bound,
    });
  }

  setIsGambleLose(bool) {
    this.isGambleLose = bool;
  }

  setTotalWinAmount(amount) {
    this.totalWinAmount = amount;
  }

  setOpenedCard(openedCard) {
    this.openedCard = openedCard;
  }

  setIsAllowDoGambleAction(bool) {
    this.isAllowDoGambleAction = bool;
  }

  setGambleHistoryCards(cards) {
    this.gambleHistoryCards = cards;
  }

  updateGambleHistoryCards(card) {
    const model = {
      card,
      index: Date.now(),
    };
    let historyCards = [model, ...this.gambleHistoryCards];
    if (historyCards.length > 8) {
      historyCards = historyCards.slice(-8);
    }
    this.setGambleHistoryCards(historyCards);
  }

  setIsShowGamblePopup(bool) {
    this.isShowGamblePopup = bool;
  }

  setGambleInfo(gambleInfo) {
    this.gambleInfo = gambleInfo;
  }

  updateGambleInfo(params) {
    this.gambleInfo = { ...this.gambleInfo, ...params };
  }

  resetGambleState() {
    this.setIsShowGamblePopup(false);
    this.setIsAllowDoGambleAction(true);
    this.setGambleInfo(null);
    this.setOpenedCard(null);
    this.setTotalWinAmount(0);
    this.setIsGambleLose(false);
  }

  setHasGamble(bool) {
    this.hasGamble = bool;
  }
}

export const gambleStore = new GambleStore();
